import React, {Component, PropTypes} from 'react'
import RadioControl from 'components/RadioControl'
import './Options.scss'

class PaymentTypes extends Component {
    
    static propTypes = {
        parameters: PropTypes.object,
        selectedCategory: PropTypes.object,
        onChangePaymentType: PropTypes.func,
        selectedPaymentType: PropTypes.string,
    }
    
    onChangePaymentType = (event, selectedPaymentType) => {
        if (this.props.onChangePaymentType && typeof this.props.onChangePaymentType === 'function') {
            this.props.onChangePaymentType(selectedPaymentType)
        }
    }
    
    render() {
        return (
            <div className="Options">
                <div className="Options-paymentTypes">
                    <div className="Options-labelBox">
                        <div className="Options-label">Способ оплаты</div>
                    </div>
                    <div>
                        <div className="Options-valueBar">
                            <div className="Options-value">
                                <RadioControl
                                    name="payment_type"
                                    label=""
                                    value={this.props.parameters.payment_online.get('name')}
                                    checked={this.props.selectedPaymentType === this.props.parameters.payment_online.get('name')}
                                    onChange={this.onChangePaymentType.bind(this)}/>
                            </div>
                            <div>
                                {this.props.parameters.payment_online.get('title')}
                                <div className="Options-valueBarTip">для физических лиц</div>
                            </div>
                        </div>
                        <div className="Options-valueBar">
                            <div className="Options-value">
                                <RadioControl
                                    name="payment_type"
                                    label=""
                                    value={this.props.parameters.payment_invoice.get('name')}
                                    checked={this.props.selectedPaymentType === this.props.parameters.payment_invoice.get('name')}
                                    onChange={this.onChangePaymentType.bind(this)}/>
                            </div>
                            <div>
                                {this.props.parameters.payment_invoice.get('title')}
                                <div className="Options-valueBarTip">оплата по счету банковским переводом</div>
                            </div>
                        </div>
                        <div className="Options-valueBar">
                            <div className="Options-value">
                                <RadioControl
                                    name="payment_type"
                                    label=""
                                    value={this.props.parameters.payment_cash.get('name')}
                                    checked={this.props.selectedPaymentType === this.props.parameters.payment_cash.get('name')}
                                    onChange={this.onChangePaymentType.bind(this)}/>
                            </div>
                            <div>
                                {this.props.parameters.payment_cash.get('title')}
                                {/*<div className="Options-valueBarTip">для физических лиц</div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default PaymentTypes



// WEBPACK FOOTER //
// ./client/components/InstantBookingScreen/PaymentTypes.js